import React from "react";
import { useTranslation } from "react-i18next";
import { TestimonialPhoto } from "../assets/testimonialPhoto";
import { Quotes } from "../assets/quotes";
import highlightWiseMate from "../hooks/highlightWord";

export const Testimonial = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full flex justify-center px-4" id="testimonials">
      <div className="relative flex flex-col md:flex-row w-full max-w-[840px] rounded-[13px] p-[1px]">
        <div
          className="absolute inset-0 rounded-[13px] p-[2px] pointer-events-none"
          style={{
            background: "linear-gradient(115deg, #EFE6FF, #6C3BC7)",
            maskImage: "linear-gradient(white, white)",
            WebkitMaskImage: "linear-gradient(white, white)",
          }}
        />
        <div
          className="relative w-full h-full rounded-[12px] p-6 md:p-[28px] flex flex-col md:flex-row gap-6 md:gap-[60px]"
          style={{
            background:
              "linear-gradient(115deg, #FFF 8.9%, #FFF 27.86%, #F5F0FF 41.56%, #FFF 53.16%, #FFF 66.6%, #F5F0FF 73.67%, #FFF 83.23%)",
          }}
        >
          <div className="flex justify-center md:block">
            <TestimonialPhoto />
          </div>
          <div className="flex flex-col gap-6 md:gap-[26px] text-center md:text-left">
            <Quotes />
            <p className="text-[14px] md:text-[16px] font-500 text-neutral-200 font-sans leading-relaxed">
              {highlightWiseMate(
                t("testimonial.description"),
                "font-700",
                true
              )}
            </p>
            <div className="flex flex-col gap-1">
              <p className="font-700 text-neutral-200 text-[16px] md:text-[18px]">
                {String(t("testimonial.author"))}
              </p>
              <p className="font-600 text-[12px] text-neutral-200">
                {String(t("testimonial.level"))} |{" "}
                {String(t("testimonial.department"))}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
